export default (syntax?: { start: string; end: string }) => {
  const syntaxToRegex = syntax || {
    start: "*|",
    end: "|*",
  };
  const startMtRegex = "\\" + syntaxToRegex.start.split("").join("\\");
  const endMtRegex = "\\" + syntaxToRegex.end.split("").join("\\");

  return `${startMtRegex}([a-zA-Z_0-9\\.\\[\\]]+)${endMtRegex}`;
};
